import React, { Fragment, useMemo } from 'react';
import { useNetworkareaFilterCategory } from '../../../../../../data/hooks/participant/useNetworkareaFilterCategory';
import useAnimatedVisibility from '../../../../../elements/AnimatedVisiblilty/useAnimatedVisibility';
import styles from './BubbleInfo.module.scss';

const BubbleInfo = props => {
    const {className = '', event, user, visible, infoPosition} = props,
        {mounted, visible: isVisible, showing, hiding} = useAnimatedVisibility({visible, timeout: 1500}),
        profile = [user.position, user.company].filter(i => i),
        category = useNetworkareaFilterCategory(event.id),
        answers = useMemo(() => {
            const {extra_profile_data} = user,
                answers = extra_profile_data?.filter(cat => cat).find(cat => category && cat.name == category.name)?.value || [];
            return answers;
        }, [user, category]);

    // useEffect(() => {
    //     if (mounted) {
    //         console.log('DEBUG', user, category, answers);
    //     }
    // }, [mounted, user, category, answers]);

    if (!mounted) return null;

    return (
        <div className={[styles.BubbleInfo, className, isVisible ? styles.visible : styles.hidden, styles[`infoPosition-${infoPosition}`]].join(' ')}>
            <h2>
                {user.first_name} {user.last_name}
            </h2>
            {profile.length ? (
                <h3>
                    {profile.map((l, i) => (
                        <Fragment key={i}>
                            {l}
                            <br />
                        </Fragment>
                    ))}
                </h3>
            ) : null}
            {answers?.map((answer, i) => (
                <div className={styles.answer} key={i}>
                    {answer}
                </div>
            ))}
        </div>
    );
};

export default BubbleInfo;
